import { useState } from 'react';
import { testimonials } from '../../../mocks/services';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonios" className="py-20 bg-gradient-to-br from-teal-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Opiniones de <strong>nuestros clientes</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            La confianza de nuestros clientes en Gran Canaria es nuestro mayor logro
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex items-center justify-center mb-6">
              {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-2xl text-yellow-400"></i>
              ))}
            </div>

            <p className="text-xl text-gray-700 text-center mb-8 leading-relaxed italic">
              "{testimonials[currentIndex].comment}"
            </p>

            <div className="text-center">
              <h4 className="text-lg font-bold text-gray-900">
                {testimonials[currentIndex].name}
              </h4>
              <p className="text-sm text-gray-600">{testimonials[currentIndex].location}</p>
              <p className="text-xs text-gray-500 mt-1">{testimonials[currentIndex].date}</p>
            </div>
          </div>

          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-700"></i>
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-700"></i>
          </button>

          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-teal-500 w-8' : 'bg-gray-300'
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;